import React, { useEffect } from 'react';
import { FormattedMessage, FormattedDate } from 'react-intl';
import {
  NavbarComponent,
  NavigationMenuComponent,
} from '../../organisms/organisms.index';
import './LiliSocialBank.component.scss';
import { makeSelectLiliSocialBank } from '../../../store/bank/bank.selectors';
import { useSelector, useDispatch } from 'react-redux';
import { loadLiliSocialBank } from '../../../store/bank/bank.actions';
import { ILiliSocialBank } from '../../../domain/bank.interface';
import { getAssetUrl } from '../../../utils/GetAssetUrl';
import { formatNumberToCurrency } from '../../../utils/FormNormalizers';

export function LiliSocialBankComponent(props: any) {
  const liliSocialBank: ILiliSocialBank = useSelector(
    makeSelectLiliSocialBank(),
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadLiliSocialBank());
    // eslint-disable-next-line
  }, []);
  const amount = !!liliSocialBank ? formatNumberToCurrency(liliSocialBank.amount as number) : 0;
  return (
    <div className='page-container'>
      <NavbarComponent />
      <NavigationMenuComponent {...props} />
      <div className='content-wrapper'>
        <h6 className='subtitle'>
          <FormattedMessage id='pages.lili-social-bank.title' />
        </h6>
        <div className='lili-social-bank-container'>
          <div
            className='lili-social-bank-image'
            style={{
              backgroundImage: `url(${getAssetUrl.icons('LILI_HAPPY.svg')})`,
            }}
          ></div>
          {!!liliSocialBank && (
            <div className='lili-social-bank-content'>
              <h4>
                <FormattedMessage id='pages.lili-social-bank.amount' />
              </h4>
          <h2 className='text-primary'>{amount}</h2>
              <h4>
                <FormattedMessage id='pages.lili-social-bank.donation-date' />
                {': '}
              </h4>
              <h4 className='text-primary'>
                <FormattedDate
                  value={liliSocialBank.donationDate}
                  year='numeric'
                  month='long'
                  day='2-digit'
                />
              </h4>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
